import jsQR from 'jsqr'
import { logError } from '@/apis/log'
interface GetMediaStreamParam {
  userId: number
}

export const scanQrFromNativeCamera = async (callback: (err: any, url?: string) => void) => {
  const cameraInput = document.querySelector('#cameraInput')! as HTMLInputElement
  cameraInput.value = ''

  const listener = (e: Event) => {
    const file = (e.target as HTMLInputElement).files![0]

    if (file) {
      const fr = new FileReader()
      fr.onload = (e) => {
        const image = document.querySelector('#cameraImage') as HTMLImageElement
        image.src = e.target?.result as string
        image.onload = () => {
          // 크롬 내장 QrCode 스캐너가 있다면, 내장 QrCode 스캐너를 사용합니다.
          if (window.BarcodeDetector != null) {
            const barcodeDetector = new window.BarcodeDetector({ formats: ['qr_code'] })
            ;(barcodeDetector.detect(image) as Promise<any>)
              .then((result) => {
                if (result) {
                  callback(null, result[0]?.rawValue)
                } else {
                  callback(null)
                }
              })
              .catch((err) => {
                callback(err)
              })
          } else {
            const cnv = document.createElement('canvas')
            const w = (cnv.width = image.width)
            const h = (cnv.height = image.height)
            const ctx = cnv.getContext('2d') as CanvasRenderingContext2D
            const baseSize = Math.floor(Math.min(w, h) / 2)
            const [left, top] = [Math.floor((w - baseSize) / 2), Math.floor((h - baseSize) / 2)]
            ctx.drawImage(image, left, top, baseSize, baseSize, 0, 0, baseSize, baseSize)
            const imageData = ctx.getImageData(0, 0, baseSize, baseSize)
            const result = jsQR(imageData.data, baseSize, baseSize)
            callback(null, result?.data)
          }
        }
      }
      fr.readAsDataURL(file)
    }

    cameraInput.removeEventListener('change', listener)
  }

  cameraInput.addEventListener('change', listener, false)
  cameraInput.click()
}

export const getMediaStream = async ({ userId }: GetMediaStreamParam): Promise<MediaStream> => {
  if (window.isMobile.any) {
    const baseMediaOptions = {
      audio: false,
      video: {
        aspectRatio: 1,
        width: {
          max: 640,
        },
        height: {
          max: 640,
        },
        facingMode: {
          exact: 'environment',
        },
      },
    }

    const deviceVideoOptions = await navigator.mediaDevices.enumerateDevices().then((deviceInfos) =>
      deviceInfos
        .filter((deviceInfo) => deviceInfo.kind === 'videoinput')
        .filter((deviceInfo) => deviceInfo.label && deviceInfo.label.includes('facing back'))
        .sort((a, b) => a.label < b.label ? -1 : a.label > b.label ? 1 : 0)
        .flatMap((deviceInfo) => ({
          audio: false,
          video: {
            aspectRatio: 1,
            deviceId: { exact: deviceInfo.deviceId },
            width: {
              max: 640,
            },
            height: {
              max: 640,
            },
          },
        }))
    )

    const options = [...deviceVideoOptions, baseMediaOptions]

    for (const option of options) {
      try {
        return await navigator.mediaDevices.getUserMedia(option)
      } catch (e: any) {
        const errObject = Object.getOwnPropertyNames(Object.getPrototypeOf(e)).reduce(
          (p: any, key) => {
            p[key] = e[key]
            return p
          },
          { videoOption: option, userId }
        )
        logError(errObject).catch((err) => console.error(err))
      }
    }
    return await navigator.mediaDevices.getUserMedia({
      audio: false,
      video: true,
    })
  }

  return navigator.mediaDevices.getUserMedia({
    audio: false,
    video: true,
  })
}
